import React from "react";
import classes from "./PageHeading.module.css";
import clsx from "clsx";
const PageHeading = ({ label, className, children, ...rest }) => {
  return (
    <h2 className={clsx(classes.heading, className)} {...rest}>
      {label || children}
    </h2>
  );
};

export default PageHeading;
